import React from 'react';
import { motion } from 'framer-motion';
import './BusinessCard.css';

const BusinessCard = ({ name, role, photo, telegram, email }) => {
  return (
    <div className="card-page">
      <meta name="robots" content="noindex, nofollow" />
      <motion.div 
        className="card-container liquid-glass"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="card-photo-wrapper">
          <img src={photo} alt={name} className="card-photo" />
        </div>
        <h1 className="card-name">{name}</h1>
        <p className="card-role">{role}</p>
        
        <div className="card-links">
          <a href={`https://${telegram}`} target="_blank" rel="noopener noreferrer" className="card-link telegram">
            Telegram
          </a>
          <a href={`mailto:${email}`} className="card-link email">
            {email}
          </a>
        </div>

        <div className="card-actions">
          <a href="/" className="card-btn primary">
            Перейти на сайт
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default BusinessCard;
